import { render, staticRenderFns } from "./IconMenuOp.vue?vue&type=template&id=d495e0d4"
import script from "./IconMenuOp.vue?vue&type=script&lang=js"
export * from "./IconMenuOp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports